import { cn } from '@/lib/utils'

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
    children: React.ReactNode
}

export default function Card({ children, className, ...rest }: IProps) {
    return (
        <div
            className={cn(`dark:bg-card rounded-lg shadow-md p-4`, className)}
            {...rest}
        >
            {children}
        </div>
    )
}
